<template>
    <div>
        <BarChart :chartData="chartDataSet" :options="chartOptions" :height="chartHeight" />
    </div>
</template>

<script>
import { BarChart } from 'vue-chart-3';
import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(...registerables, ChartDataLabels);

export default {
    name: 'BarChartPortfolio',
    components: { BarChart },
    props: {
        data: {
            type: Object
        }
    },
    data() {
        return {
            originValue: [],
            chartDataSet: {
                labels: ['one', 'two', 'three', 'four', 'five'],
                datasets: [
                    {
                        barPercentage: val => {
                            return this.isMobile() ? 0.7 : 0.6;
                        },
                        // categoryPercentage: 0.5,
                        data: [[50, 30], 40, 60, 70, 5],
                        backgroundColor: ['#77CEFF', '#77CEFF', '#77CEFF', '#77CEFF', '#77CEFF']
                        // barThickness: 26,
                        // maxBarThickness: 28,
                        // minBarLength: 40,
                    }
                ]
            },
            chartOptions: {
                animations: false,
                responsive: true,
                borderSkipped: false,
                borderRadius: {
                    topRight: 4,
                    topLeft: 4,
                    bottomLeft: context => {
                        if (context.dataIndex === 0 || context.dataIndex === this.data.length - 1) {
                            return 0;
                        } else {
                            return 4;
                        }
                    },
                    bottomRight: context => {
                        if (context.dataIndex === 0 || context.dataIndex === this.data.length - 1) {
                            return 0;
                        } else {
                            return 4;
                        }
                    }
                },
                hover: {
                    mode: null // Отмена реакции на наведение
                },
                layout: {
                    padding: {
                        top: () => {
                            return this.isMobile() ? 0 : 50;
                        },
                        right: () => {
                            return this.isMobile() ? 0 : 16;
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: false
                    },
                    datalabels: {
                        color: (value, index) => {
                            if (value.dataIndex === 0 || value.dataIndex === value.dataset.data.length - 1) {
                                return '#252628';
                            } else return value.dataset.backgroundColor[value.dataIndex];
                        },
                        font: () => {
                            let font = {
                                size: this.isMobile() ? 14 : 20,
                                family: 'Gilroy-SemiBold, sans-serif',
                                weight: '600'
                            };
                            return font;
                        },
                        anchor: 'end', // Позиционирование подписей относительно бара
                        align: 'top', // Выравнивание подписей относительно бара
                        offset: 1, // Отступ от бара
                        formatter: (value, index) => {
                            if (index.dataIndex === 0 || index.dataIndex === index.dataset.data.length - 1) {
                                return this.originValue[index.dataIndex].value;
                            } else if (this.toNumber(this.originValue[index.dataIndex].value) > 0) {
                                return `+${this.originValue[index.dataIndex].value}`;
                            } else return this.originValue[index.dataIndex].value;
                        } // Форматирование значения подписи
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            backdropPadding: 0,
                            padding: 0,
                            color: '#999',
                            font: {
                                size: 12,
                                family: 'Gilroy-Medium, sans-serif',
                                weight: '500'
                            },
                            offset: 10,
                            callback: function (value, index, ticks) {
                                let val = this.getLabelForValue(value);
                                let splittedValue = val.split(' ');
                                let newVal;
                                if (splittedValue.length > 2) {
                                    newVal = splittedValue.slice(0, -1).join(' ');

                                    return [newVal, splittedValue[splittedValue.length - 1]];
                                } else return splittedValue;
                            }
                        },

                        grid: {
                            display: false,
                            borderColor: '#999'
                        }
                    },
                    y: {
                        ticks: {
                            mirror: () => {
                                return this.isMobile();
                            },
                            padding: () => {
                                return this.isMobile() ? 5 : 0;
                            },
                            color: '#999',
                            font: {
                                size: 12,
                                family: 'Gilroy-Medium, sans-serif',
                                weight: '500'
                            },
                            callback: (value, index, ticks) => {
                                if (index === ticks.length - 1) {
                                    return this.isMobile() ? ['трлн', '₽'] : ['трлн ₽'];
                                } else return '';
                            }
                        },
                        grid: {
                            borderColor: '#999',
                            display: false
                        }
                    }
                }
            }
        };
    },
    computed: {
        isDesktop() {
            return document.documentElement.clientWidth >= 1124;
        },
        chartHeight() {
            return this.isDesktop ? 300 : 300;
        },
        chartWidth() {
            return this.isDesktop ? 900 : 790;
        }
    },
    beforeMount() {
        this.chartDataSet.labels.length = 0;
        this.chartDataSet.datasets[0].data.length = 0;

        let maxValue;
        let ratio = 10;

        this.originValue = this.data.map(el => el);
        //проверка, есть ли в промежуточных (между первым и последним столбцом) значения >= единице
        let isHighThenOne = this.data.slice(1, this.data.length - 1).every(el => Math.abs(Number(el.value.replace(',', '.'))) <= 2);

        this.data.forEach((element, idx) => {
            this.chartDataSet.labels[idx] = element.name;
            if (idx === 0 || idx === this.data.length - 1) {
                this.chartDataSet.datasets[0].backgroundColor[idx] = '#9ac2ff';
                if (idx === 0) {
                    maxValue = this.toNumber(element.value);
                }
                this.chartDataSet.datasets[0].data[idx] = this.toNumber(element.value);
                if (idx === this.data.length - 1) {
                    // высота последнего столбца - это отметка начала предпоследнего
                    this.chartDataSet.datasets[0].data[idx] = this.chartDataSet.datasets[0].data[idx - 1][1];
                }
            } else {
                let currentEl = this.toNumber(element.value);
                if (currentEl > 0) {
                    this.chartDataSet.datasets[0].backgroundColor[idx] = '#82bf00';
                } else if (currentEl < 0) {
                    this.chartDataSet.datasets[0].backgroundColor[idx] = '#de4a2a';
                }

                if (isHighThenOne) {
                    currentEl = currentEl * ratio;
                } else {
                    currentEl = currentEl * 2;
                }
                let numSt = maxValue;
                let numEnd = maxValue + currentEl;
                maxValue = numEnd;
                this.chartDataSet.datasets[0].data[idx] = [numSt, maxValue];
            }
        });
    },
    methods: {
        toNumber(val) {
            if (val) {
                return Number(val.replace(',', '.'));
            }
        },
        isMobile() {
            return document.documentElement.clientWidth <= 768;
        }
    }
};
</script>
